import React from "react";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
const RichTextPanel = ({
  className,
  text,
  id
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, text && /*#__PURE__*/React.createElement(RichText, {
    id: id,
    className: `rich-text ${typeof className !== "undefined" ? className : ""}`,
    field: text
  }));
};
export default RichTextPanel;